import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  quizzes: [],
  currentQuiz: null,
  isLoading: false,
  error: null,
};

const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setQuizzes: (state, action) => {
      state.quizzes = action.payload;
    },
    addQuiz: (state, action) => {
      state.quizzes.push(action.payload);
    },
    updateQuiz: (state, action) => {
      const index = state.quizzes.findIndex(q => q._id === action.payload._id);
      if (index !== -1) {
        state.quizzes[index] = action.payload;
      }
    },
    removeQuiz: (state, action) => {
      state.quizzes = state.quizzes.filter(q => q._id !== action.payload);
    },
    setCurrentQuiz: (state, action) => {
      state.currentQuiz = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setQuizzes,
  addQuiz,
  updateQuiz,
  removeQuiz,
  setCurrentQuiz,
  clearError,
} = quizSlice.actions;

export default quizSlice.reducer;

